export const Project = 'Project'
export const Product = 'Product'
export const Stat    = 'Stats'
export const Search  = 'Search'
